import {datadogRum} from '@datadog/browser-rum';
import constants from 'util/data/constants';
import {datadogLogs} from '@datadog/browser-logs';

const clientToken = 'pub62e4f433fb198720fba480562ef91ac1';

// Adding separate util so that it can be turned on in a single switch for local dev & debugging
const isDeployed = () => {
    return constants.isDeployed;
};

class LogManager {
    constructor() {
        this.pageLoadStartTime = 0;
        this.stuckTimeout = 0;
        this.trackedPageLoad = false;
        this.loadingStuck = false;
        this.pageLoadStartTime = performance.now();
        this.startTrackingIfLoadingStuck(); // Track at initial page load AND again when loader is displayed, so that we can check when switching betweeen projects too
    }

    startTrackingIfLoadingStuck() {
        clearTimeout(this.stuckTimeout);
        this.stuckTimeout = setTimeout(() => {
            if (document.hidden) {
                this.restartLoadingTimerWhenWindowIsActive();
                return;
            }
            this.loadingStuck = true;
            m.redraw();
            if (isDeployed()) {
                datadogRum.addTiming('page_load_stuck', performance.now() - this.pageLoadStartTime);
            }
            if (this.windowVisibilityListener) {
                document.removeEventListener('visibilitychange', this.windowVisibilityListener);
                this.windowVisibilityListener = null;
            }
        }, 60000);
    }

    restartLoadingTimerWhenWindowIsActive() {
        clearTimeout(this.stuckTimeout);
        this.windowVisibilityListener = this.startTrackingIfLoadingStuck.bind(this);
        document.addEventListener('visibilitychange', this.windowVisibilityListener);
    }
 
    closeLoadingStuck() {
        this.loadingStuck = false;
        clearTimeout(this.stuckTimeout);
        m.redraw();
    }

    trackGetUserDuration(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('get_user_duration', duration);
        }
    }

    trackGetAccountDuration(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('get_account_duration', duration);
        }
    }

    trackGetProjectDataDuration(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('get_project_data_duration', duration);
        }
    }

    trackGetToolboxDuration(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('get_toolbox_duration', duration);
        }
    }

    trackListContentDuration(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('list_content_duration', duration);
        }
    }

    trackCountContentDuration(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('count_content_duration', duration);
        }
    }

    trackRefreshDuration(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('refresh_token_duration', duration);
        } 
    }

    trackStreamTimeToFirstFeature(duration) {
        if (isDeployed()) {
            datadogRum.addTiming('stream_time_to_first_feature', duration);
        }
    }
    trackStreamDuration(duration, featureCount) {
        if (isDeployed()) {
            datadogRum.addTiming('stream_duration', duration);
            datadogRum.addTiming('stream_duration_by_feature_count', duration / featureCount);
        }
    }

    trackFirstLoad() {
        if (isDeployed()) {
            const endTime = performance.now();
            if (!this.trackedPageLoad) {
                const pageLoadTime = endTime - this.pageLoadStartTime;
                datadogRum.addTiming('page_to_table_latency', pageLoadTime);
                
            }
            const accountLatency = endTime - this.accountLoadStartTime;
            datadogRum.addTiming('account_to_table_latency', accountLatency);
        }
        this.trackedPageLoad = true;
        delete this.pageLoadStartTime;
        delete this.accountLoadStartTime;
        this.closeLoadingStuck();
    }

    init() {
        if (isDeployed()) {
            const env = {
                development: 'dev',
                staging: 'staging',
                production: 'prod'
            }[constants.awsProfile];

            datadogLogs.init({
                clientToken: clientToken,
                site: 'datadoghq.com',
                env: env.awsProfile,
                service: 'unearth_web', 
                forwardErrorsToLogs: false, // If this is set to true, all console errors will go to datadog
                sessionSampleRate: 100
            });

            datadogRum.init({
                applicationId: 'a883bf60-1f1f-49f0-bee9-f3a2e8f274b1',
                clientToken,
                site: 'datadoghq.com',
                service: 'OnePlace',
                env,
                version: constants.release,
                sampleRate: 100,
                trackInteractions: true,
                beforeSend: e => {
                // Ignore all network errors related to loading tiles
                    const resource = e.resource || e.error && e.error.resource;
                    if (resource && resource.url.startsWith('https://api.mapbox.com/styles'
                    || resource.url.startsWith('https://tiles.unearthlabs.com/'))) {
                        return false;
                    }

                }
            });
        }
    }
}

export default new LogManager();
